import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import FormInputText from '../../molecules/formInputText/formInputText';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import { login, logOut, getUserRole } from '../../../store/externalCalls/api/sessionApi';
import FormValidation from '../../atoms/formEnums/formValidation';
import './loginPage.scss';
import routes, { getRoute } from '../../../routes/route';
import swal from 'sweetalert';
import ChangePasswordPopup from '../../molecules/changePasswordPopup/changePasswordPopup';
import Version from '../../atoms/version/version';
import {checkEnvironment } from '../../../utils/mainUtils';
import { resetMainMenu } from '../../../store/actions/mainMenuActions';
import { useDispatch, useSelector } from 'react-redux';

const LoginPage = () => {
  const [loginState, setLoginState] = useState({});
  const [loged, setLoget] = useState(false);
  const [popupState, setPopupState] = useState(false);
  const [userEmail, setUserEmail] = useState();
  const [captchaToken, setCaptchaToken] = useState();
  const backgroundColor = process.env.REACT_APP_BACKGROUND_COLOR;
  const envTitle = process.env.REACT_APP_ENV_TITLE;
  const dispatch = useDispatch();
  const handlerOnClickFrom = (e) => {
    e.preventDefault();
    login(loginState).then(() => {
      setLoget(true);
    }, (error) => {
      if (error == 'Expired') {
        setPopupState(true);
      }
      const message = error.message === undefined ? 'Your password has expired, please update it to use the xms' : error.message;
      swal('Error', message, 'error');
    });
  };

  const handleVerificationSuccess = (token, ekey) => {
    setCaptchaToken(token);
    const newState = { ...loginState };
    newState.token = token;
    setLoginState(newState);
  };

  const handlerOnChange = (event, attributeName) => {
    const newState = { ...loginState };
    newState[attributeName] = event.target.value;
    setUserEmail(newState.email);
    setLoginState(newState);
  };

  useEffect(() => {
    if(envTitle){
      checkEnvironment(envTitle);
    }
    dispatch(resetMainMenu());
    logOut();
  }, []);

  if (loged) {
    return <Navigate to={getRoute(routes.HOME_PAGE)} replace />;
  }

  return (
    <div className="login__background d-flex align-items-center justify-content-center" style={{backgroundColor: "#"+backgroundColor}}>
      <div className="login__frame">
        <div className="d-flex justify-content-center mb-4">
          <img
            className='login__logo'
            src={`${process.env.PUBLIC_URL}/ybvr_large.png`}
            alt="Login"
          />
          <div className="d-flex justify-content-end flex-column">
            <span className='login__env'>{envTitle}</span>
          </div>
        </div>
        <form className="login__form bg-light p-3 rounded" onSubmit={handlerOnClickFrom}>
          <FormInputText
            id="login-email"
            name="email"
            label="Email"
            placeholder="Write your email..."
            onChange={(event) => handlerOnChange(event, 'email')}
          />
          <FormInputText
            id="login-password"
            name="password"
            type={FormInputTypes.TEXT_INPUT.PASSWORD}
            label="Password"
            placeholder="Write your password..."
            onChange={(event) => handlerOnChange(event, 'password')}
          />
          <div className="form-group row hcaptcha-wrapper">
            <HCaptcha
              sitekey={process.env.REACT_APP_HCAPTCHA_SITEKEY}
              onVerify={(token, ekey) => handleVerificationSuccess(token, ekey)}
            />
          </div>
          <Button
            id="login-ok"
            className="m-auto d-block"
            type={ButtonType.SUBMIT}
            theme={ButtonTheme.PRIMARY}
          >
            Login
          </Button>
        </form>
      </div>
      <ChangePasswordPopup show={popupState} onChange={() => setPopupState(!popupState)} email={userEmail} />
      <Version />
    </div>
  );
};

export default LoginPage;
